import { OutsideClickRule } from "./outside-click"
import { EventRule } from "../models"

export const EventRules: EventRule[] = [new OutsideClickRule()]
